export default {
  common: {
    brand: "USFans Spreadsheet",
    nav: {
      home: "Strona główna",
      shoppingGuide: "Poradnik zakupowy",
      spreadsheet: "Arkusz",
      categories: "Kategorie",
      resources: "Zasoby",
      faq: "FAQ",
    },
    cta: {
      explore: "Przeglądaj arkusz",
      buyNow: "Kup teraz",
      visitMain: "Odwiedź główną stronę",
      readGuide: "Przeczytaj pełny przewodnik",
    },
    categoriesTitle: "Kupuj według kategorii",
    categoriesSubtitle: "Przeglądaj wszystkie kategorie produktów w głównym sklepie",
    browseCategories: "Przeglądaj kategorie",
    jumpCategory: "Przejdź do kategorii",
    footer: {
      tagline: "Niezależne centrum zasobów dotyczące arkusza USFans — przewodniki, recenzje i praktyczne wskazówki.",
      disclaimer: "To niezależna strona informacyjna, niezwiązana z USFans ani z głównym sklepem. Linki zewnętrzne otwierają się w nowej karcie.",
      resourcesTitle: "Zasoby",
      categoriesTitle: "Kategorie",
      legalTitle: "Informacje prawne",
      rights: "Wszelkie prawa zastrzeżone.",
    },
    backHome: "Wróć na stronę główną",
    published: "Opublikowano",
    updated: "Ostatnia aktualizacja",
    readMore: "Przeczytaj artykuł",
    languageLabel: "Język",
  },
};